import "./ContactUs.module.css";
import MainHeader from "@/reusable_sections/Header";
import InquiryPortal from "./sections/InquiryPortal";
import OfficeGlobalPresence from "./sections/OfficeGlobalPresence";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <MainHeader />
      <InquiryPortal />
      <OfficeGlobalPresence />
      <Footer />
    </div>;
}